import * as moment from 'moment'

/**
 * Check whether the current date falls between
 * two other dates
 *
 * @param {Object} dates
 * The start and end dates
 *
 * @param {Date} now
 * The current local time NOT converted to UTC
 */
const isInside = ({ startDateTime, endDateTime }: any, now: string) => {
  const nowRaw = moment(now).utcOffset(now)
  const startDateRaw = moment(startDateTime).utcOffset(startDateTime)
  const endDateRaw = moment(endDateTime).utcOffset(endDateTime)

  return moment(startDateRaw).isBefore(nowRaw) && moment(endDateRaw).isAfter(nowRaw)
}

/**
 * Check whether the current date & time falls between two other
 * dates and times
 *
 * @param {Object} dates
 * The start and end dates
 *
 * @param {Date} now
 * The current local time NOT converted to UTC
 */
const isInsideToday = (dates: any, now: string) => {
  const nowRaw = moment(now).utcOffset(now)
  const nowDay = nowRaw.format('YYYY-MM-DD')
  const openTime = `${nowDay}T${dates.openTime || '00:00:00'}`
  const closeTime = `${nowDay}T${dates.closeTime || '23:59:59'}`
  const openRaw = moment(openTime).utcOffset(openTime)
  const closeRaw = moment(closeTime).utcOffset(closeTime)

  return isInside(dates, now) && moment(openRaw).isBefore(now) && moment(closeRaw).isAfter(now)
}

/**
 * Show a notice when the campaign is closed
 * on the current date
 *
 * @param {Object} config
 * The campaign config object
 *
 * @param {Date} now
 * The current local time NOT converted to UTC
 */
const makeOutsideCampaignNotice = ({ campaignDates }: any, now: string) => {
  const nowRaw = moment(now).utcOffset(now)
  const nowTZ = nowRaw.format('Z')
  const start = moment(campaignDates.startDateTime).utcOffset(nowTZ)
  const end = moment(campaignDates.endDateTime).utcOffset(nowTZ)

  return {
    show: !isInside({ ...campaignDates }, now),
    msg: `This promotion is open between \
      ${moment(start).format('HH:mm, Do MMMM YYYY')} and \
      ${moment(end).format('HH:mm, Do MMMM YYYY')}`,
  }
}

/**
 * Show a notice when the campaign is closed
 * on the current date
 *
 * @param {Object} config
 * The campaign config object
 *
 * @param {Date} now
 * The current local time NOT converted to UTC
 */
const makeClosedTodayNotice = ({ campaignDates }: any, now: string) => {
  const nowRaw = moment(now).utcOffset(now)
  const nowDay = nowRaw.format('YYYY-MM-DD')
  const nowTZ = nowRaw.format('Z')
  const openTime = `${nowDay}T${campaignDates.openTime}`
  const closeTime = `${nowDay}T${campaignDates.closeTime}`
  const open = moment(openTime).utcOffset(nowTZ)
  const close = moment(closeTime).utcOffset(nowTZ)

  return {
    show: !isInsideToday({ ...campaignDates }, now),
    msg: `This promotion is open daily between \
      ${moment(open).format('HH:mm')} and \
      ${moment(close).format('HH:mm')}`,
  }
}

export { isInside, isInsideToday, makeOutsideCampaignNotice, makeClosedTodayNotice }
